<template>
  <form
    id="report-search-form"
    @submit.prevent="searchCalls">
    <v-container class="px-5">
      <!-- Call Problem -->
      <v-row
        v-if="isPermittedAll([
          'CustomersGetAll',
        ])">
        <v-col class="pt-0">
          <h3 class="mb-3">Filter</h3>
            <v-text-field
              id="call-problem"
              name="callProblem"
              ref="callProblem"
              v-model="reportSearchParameters.CallProblem"
              label="Call Problem:"
              :readonly="$store.getters.isLoadingActive"
              hide-details>
            </v-text-field>
        </v-col>
      </v-row>
      <!-- / Call Problem -->

      <!-- Call Notes -->
      <v-row
        v-if="isPermittedAll([
          'CallsGetAll',
        ])">
        <v-col class="pt-0">
            <v-text-field
              id="call-notes"
              name="callNotes"
              ref="callNotes"
              v-model="reportSearchParameters.CallNotes"
              label="Call Notes:"
              :readonly="$store.getters.isLoadingActive"
              hide-details>
            </v-text-field>
        </v-col>
      </v-row>
      <!-- / Call Notes -->

      <!-- Start-->
      <v-row>
        <v-col>
          <label for="calls-search-start">Calls Started Between:</label>
          <DatePicker
            input-id="calls-search-start"
            :line-bottom="false"
            v-model="reportSearchParameters.StartDateUtc"
            @input="$store.commit(
              'setSearchParameters',
              { params: {
                StartDateUtc: reportSearchParameters.StartDateUtc,
              }, paramsKey: 'reportSearchParameters' },
            )"
          />
        </v-col>
      </v-row>
      <!-- / Start -->

      <!-- End-->
      <v-row>
        <v-col>
          <DatePicker
            input-id="calls-search-end"
            :line-bottom="false"
            v-model="reportSearchParameters.EndDateUtc"
            @input="$store.commit(
              'setSearchParameters',
              { params: {
                EndDateUtc: reportSearchParameters.EndDateUtc,
              }, paramsKey: 'reportSearchParameters' },
            )"
          />
        </v-col>
      </v-row>
      <!-- / End -->

      <!-- Reset Date Range -->
      <v-row>
        <v-col>
          <v-btn
            type="button"
            color="primary"
            :disabled="$store.getters.isLoadingActive"
            @click="resetDateRangeFilter"
            outlined
            block
          >
            Reset Date Range
          </v-btn>
        </v-col>
      </v-row>
      <!-- / Reset Date Range -->

      <!-- Hidden -->
      <v-row
        v-if="isPermittedAll([
          'CallsViewDeleted'
        ])">
        <v-col>
          <label for="search-include-hidden">Hidden:</label>
          <Autocomplete
            id="search-include-hidden"
            :items="$store.state.hiddenStatuses"
            v-model="hiddenStatusSearchParameter"
            outlined
            filled>
          </Autocomplete>
        </v-col>
      </v-row>
      <!-- / Hidden -->

      <!-- Search -->
      <v-row>
        <v-col>
          <v-btn
            type="submit"
            color="success"
            outlined
            block
            :disabled="$store.getters.isLoadingActive">
            Search Calls
          </v-btn>
        </v-col>
      </v-row>
      <!-- / Search -->
    </v-container>
  </form>
</template>

<script>
import _ from 'lodash';
import DatePicker from './DatePicker.vue';

export default {
  name: 'ReportSearchForm',
  components: {
    DatePicker,
  },
  computed: {
    hiddenStatusSearchParameter: {
      get() {
        let hiddenStatus = _.find(
          this.$store.state.hiddenStatuses,
          { value: this.reportSearchParameters.HiddenStatus },
        );

        if (!hiddenStatus) {
          hiddenStatus = {
            value: undefined,
            text: this.anyOption,
          };
        }

        return hiddenStatus;
      },
      set(hiddenStatusSearchParameter) {
        const params = {
          HiddenStatus: hiddenStatusSearchParameter.value || undefined,
        };

        this.$store.commit(
          'setSearchParameters',
          { paramsKey: 'reportSearchParameters', params },
        );
      },
    },
    reportSearchParameters() {
      return this.$store.state.reportSearchParameters;
    },
  },
  methods: {
    searchCalls() {
      this.$store.dispatch('getReportCalls');
      this.$store.dispatch('getOpenCalls');
    },
    resetDateRangeFilter() {
      this.$store.dispatch('resetDateRangeFilter');
      this.searchCalls();
    },
  },
};
</script>

<style lang="scss"></style>
